var _path, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 21.25",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,9.2h-0.7V4.8c0-0.5-0.4-1-1-1h-1.1L13.8,2c0.3-0.5,0.1-1.1-0.3-1.4C12.9,0.4,12.3,0.5,12,1l-1.7,2.9H6.7L5,1  C4.7,0.5,4.1,0.4,3.6,0.6C3.1,0.9,3,1.5,3.2,2l1.1,1.8H3.2c-0.5,0-1,0.5-1,1v4.3H1.5c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h0.7v4.3  c0,0.5,0.5,1,1,1h10.5c0.5,0,1-0.5,1-1v-4.3h0.7c0.6,0,1-0.4,1-1C16.5,9.6,16.1,9.2,15.5,9.2z M5.3,8.3c0-0.6,0.4-1,1-1  c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1C5.8,9.3,5.3,8.9,5.3,8.3z M9.7,13H7.3c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h2.4c0.6,0,1,0.4,1,1  C10.7,12.6,10.3,13,9.7,13z M10.7,9.3c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C11.7,8.9,11.2,9.3,10.7,9.3z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 32,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Creative Stall")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 37,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.88af3e2fff9fa0ba373afd9447d7b6c7.svg";
export { ForwardRef as ReactComponent };